var exports = {
  "kL": "HandoffCodeDisplay.module__container___QU1Gcl",
  "DD": "HandoffCodeDisplay.module__title___QU1Gcl",
  "h_": "HandoffCodeDisplay.module__description___QU1Gcl",
  "w5": "HandoffCodeDisplay.module__expiredDescription___QU1Gcl",
  "ZP": "HandoffCodeDisplay.module__codeSection___QU1Gcl",
  "cg": "HandoffCodeDisplay.module__codeLabel___QU1Gcl",
  "w8": "HandoffCodeDisplay.module__codeDisplay___QU1Gcl",
  "IL": "HandoffCodeDisplay.module__codeChar___QU1Gcl",
  "lr": "HandoffCodeDisplay.module__codeSeparator___QU1Gcl",
  "O1": "HandoffCodeDisplay.module__timer___QU1Gcl",
  "u1": "HandoffCodeDisplay.module__spinner___QU1Gcl",
  "Fh": "HandoffCodeDisplay.module__spinnerIcon___QU1Gcl",
  "t0": "HandoffCodeDisplay.module__spin___QU1Gcl",
  "z3": "HandoffCodeDisplay.module__error___QU1Gcl",
};

module.exports = exports;
